import axiosInstance from "../axiosInstance"
import type {
  PlanResponseDto,
  CreatePlanDto,
  UpdatePlanDto,
  PlanListParams,
  DeletePlanResponseDto,
} from "../types/plan.types"

/**
 * Plan API Client
 * Direct API calls using axios instance
 */
export const planClient = {
  // Get plan by ID (any status, admin)
  getPlanByIdAdmin: (id: string): Promise<PlanResponseDto> => {
    return axiosInstance.get(`/plans/admin/${id}`)
  },

  // List plans with optional filters (admin)
  // Returns PlanResponseDto[] directly (array, not paginated)
  getPlansAdmin: (params?: PlanListParams): Promise<PlanResponseDto[]> => {
    // Filter out undefined values to avoid sending them to the API
    const apiParams: Record<string, string | boolean> = {}
    
    if (params) {
      if (params.target !== undefined) {
        apiParams.target = params.target
      }
      if (params.isActive !== undefined) {
        apiParams.isActive = params.isActive
      }
    }
    
    return axiosInstance.get("/plans/admin", { params: apiParams })
  },

  // Create plan (Admin only)
  createPlan: (data: CreatePlanDto): Promise<PlanResponseDto> => {
    return axiosInstance.post("/plans", data)
  },

  // Update plan (Admin only)
  updatePlan: (id: string, data: UpdatePlanDto): Promise<PlanResponseDto> => {
    return axiosInstance.put(`/plans/${id}`, data)
  },

  // Delete plan (Admin only)
  deletePlan: (id: string): Promise<DeletePlanResponseDto> => {
    return axiosInstance.delete(`/plans/${id}`)
  },
}

